var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "form",
    staticClass: "demo-form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Dealer",
      prop: "dealerId",
      required: ""
    }
  }, [_c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      remote: "",
      loading: _vm.dealerListLoading,
      "loading-text": "fetching dealers..",
      "remote-method": _vm.getDealerList,
      placeholder: "Search Dealer"
    },
    model: {
      value: _vm.form.dealerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "dealerId", $$v);
      },
      expression: "form.dealerId"
    }
  }, _vm._l(_vm.dealerList, function (dealer) {
    return _c("el-option", {
      key: dealer.id,
      attrs: {
        label: dealer.name,
        value: dealer.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(dealer.name) + " - " + _vm._s(dealer.code))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("   | ID: " + _vm._s(dealer.id))])]);
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Invoice Number",
      prop: "invoiceNumber",
      required: ""
    }
  }, [_c("el-input", {
    attrs: {
      name: "invoiceNumber",
      placeholder: "Invoice Number"
    },
    model: {
      value: _vm.form.invoiceNumber,
      callback: function ($$v) {
        _vm.$set(_vm.form, "invoiceNumber", $$v);
      },
      expression: "form.invoiceNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Invoice Date",
      prop: "invoiceDate",
      required: ""
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      placeholder: "Invoice Date",
      "value-format": "yyyy-MM-dd",
      format: "yyyy-MM-dd"
    },
    model: {
      value: _vm.form.invoiceDate,
      callback: function ($$v) {
        _vm.$set(_vm.form, "invoiceDate", $$v);
      },
      expression: "form.invoiceDate"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Grand Total",
      prop: "grandTotal",
      required: ""
    }
  }, [_c("el-input", {
    attrs: {
      name: "grandTotal",
      placeholder: "Grand Total"
    },
    model: {
      value: _vm.form.grandTotal,
      callback: function ($$v) {
        _vm.$set(_vm.form, "grandTotal", $$v);
      },
      expression: "form.grandTotal"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Sub Total",
      prop: "subTotal"
    }
  }, [_c("el-input", {
    attrs: {
      name: "subTotal",
      placeholder: "Sub Total"
    },
    model: {
      value: _vm.form.subTotal,
      callback: function ($$v) {
        _vm.$set(_vm.form, "subTotal", $$v);
      },
      expression: "form.subTotal"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Discount Amount",
      prop: "discountAmount"
    }
  }, [_c("el-input", {
    attrs: {
      name: "discountAmount",
      placeholder: "Discount Amount"
    },
    model: {
      value: _vm.form.discountAmount,
      callback: function ($$v) {
        _vm.$set(_vm.form, "discountAmount", $$v);
      },
      expression: "form.discountAmount"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Tax Amount",
      prop: "taxAmount"
    }
  }, [_c("el-input", {
    attrs: {
      name: "taxAmount",
      placeholder: "Tax Amount"
    },
    model: {
      value: _vm.form.taxAmount,
      callback: function ($$v) {
        _vm.$set(_vm.form, "taxAmount", $$v);
      },
      expression: "form.taxAmount"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Round Off Amount",
      prop: "roundOffAmount"
    }
  }, [_c("el-input", {
    attrs: {
      name: "roundOffAmount",
      placeholder: "Round Off Amount"
    },
    model: {
      value: _vm.form.roundOffAmount,
      callback: function ($$v) {
        _vm.$set(_vm.form, "roundOffAmount", $$v);
      },
      expression: "form.roundOffAmount"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "reset"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };